var path = 'app/core/views/noPermissions.html';
var html = "<div class=\"flex flex__group flex_center-h\" style=\"font-size: 1.3rem\">\n  <span>{{'admin.userManagement.permissionTabs.noPermissions' | i18n}}</span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;